import {
  FETCH_UPDATE_ANNOUNCEMENT_REQUEST,
  FETCH_UPDATE_ANNOUNCEMENT_SUCCESS,
  FETCH_UPDATE_ANNOUNCEMENT_FAILURE,
  SET_UPDATE_ANNOUNCEMENT,
} from "../../actions/announcement/update-announcement-actions";

const initialState = {
  updatedAnnouncement: null,
  announcement: null,
  isLoading: false,
  error: null,
};

const CLEAR_DATA = "CLEAR_DATA";
const UpdateAnnouncementReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case FETCH_UPDATE_ANNOUNCEMENT_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case SET_UPDATE_ANNOUNCEMENT:
      return {
        ...state,
        isLoading: false,
        error: null,
        announcement: { ...action.payload },
        announcementDetailed: { ...action.payload },
      };
    case FETCH_UPDATE_ANNOUNCEMENT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        updatedAnnouncement: action.payload[0],
      };
    case FETCH_UPDATE_ANNOUNCEMENT_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    case CLEAR_DATA:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export default UpdateAnnouncementReducer;
